import { api } from './api';

async function listPixels(productId): Promise<any> {
  const response = await api.get(`/v1/products/${productId}/pixel-integrations`);

  return response.data;
}

async function createPixel({
  productId,
  data,
}: {
  productId: string;
  data: any;
}): Promise<any> {
  // Precisa devolver o pixel criado (id/pixelProvider) — usePixels.ts's onSuccess e o
  // fluxo de auto-abrir a EditPixelSheet do Google Ads dependem desse retorno.
  const response = await api.post(`/v1/products/${productId}/pixel-integrations`,
    data,
  );

  return response.data;
}

async function updatePixel({
  productId,
  pixelId,
  data,
}: {
  productId: string;
  pixelId: string;
  data: any;
}) {
  await api.put(`/v1/products/${productId}/pixel-integrations/${pixelId}`,
    data,
);
}

async function viewPixel({
  productId,
  pixelId,
}: {
  productId: string;
  pixelId: string;
}) {
  const response = await api.get(
    `/v1/products/${productId}/pixel-integrations/${pixelId}`
  );

  return response.data.data;
}

export interface PixelConversionAction {
  event_type: string;
  conversion_action_id: string;
  conversion_action_name: string;
  conversion_action_category: string;
  gtag_send_to: string | null;
}

async function assignGoogleAdsConversionAction({
  productId,
  pixelId,
  event_type,
  conversion_action_id,
}: {
  productId: string;
  pixelId: string;
  event_type: string;
  conversion_action_id: string;
}): Promise<PixelConversionAction> {
  const response = await api.put(
    `/v1/products/${productId}/pixel-integrations/${pixelId}/google-ads/conversion-actions`,
    { event_type, conversion_action_id }
  );

  return response.data.data;
}

// event_type é o valor cru do enum (ex.: "purchase") — mesmo formato usado em
// assignGoogleAdsConversionAction, identifica a associação a remover (chave
// composta pixel_integration_id + event_type no backend).
async function unlinkGoogleAdsConversionAction({
  productId,
  pixelId,
  event_type,
}: {
  productId: string;
  pixelId: string;
  event_type: string;
}): Promise<void> {
  await api.delete(
    `/v1/products/${productId}/pixel-integrations/${pixelId}/google-ads/conversion-actions/${event_type}`
  );
}

async function deletePixel({
                             productId,
                             pixelId,
                           }: {
  productId: string;
  pixelId: string;
}) {
  await api.delete(`/v1/products/${productId}/pixel-integrations/${pixelId}`);
}

export const PixelService = { listPixels, deletePixel, createPixel, updatePixel, viewPixel, assignGoogleAdsConversionAction, unlinkGoogleAdsConversionAction };